import React from "react";

// B5 part 2c: inserts a whitelisted {{merge_field}} at the editor cursor. Unknown fields are refused by the server.
export default function MergeFieldPicker({ fields, labels, onInsert }) {
  return (
    <fieldset className="border border-erf-borderCream rounded bg-white p-3" data-testid="tpl-merge-picker">
      <legend className="text-xs uppercase font-nav text-erf-dark/60 px-1">Insert merge field</legend>
      <div className="flex flex-wrap gap-2">
        {fields.map((f) => (
          <button key={f} type="button" onClick={() => onInsert(f)} title={labels?.[f] || f}
            className="min-h-[44px] px-3 rounded-sm border border-erf-borderCream text-xs font-mono bg-erf-creamSecondary hover:bg-erf-cream transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-erf-dark"
            data-testid={`tpl-field-${f}`}>
            {`{{${f}}}`}
          </button>
        ))}
      </div>
    </fieldset>
  );
}
